import {Button, Layout, Tabs, Typography} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import AssumptionsT1 from './AssumptionsT1';
import AssumptionsT2 from './AssumptionsT2';

const {Paragraph, Text} = Typography;
const {Content} = Layout;

const AssumptionsTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno('white');
      setGUno(appColors['ColorX']);
    }
  };
  const items_ = [
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>First barcode LFA<br/>model</Button>, key: 'uno', children: <AssumptionsT1/>},
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Improved barcode LFA<br/>model</Button>, key: 'dos', children: <AssumptionsT2/>},
  ];
  return (
    <Layout style={{margin: '5.2vh 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Assumptions</Paragraph>
        <Text className='BaseText6'>The fact that we have redesigned some features of our device have helped to reduce the number of assumptions made for each model (e.g. we are now using serum instead of plasma, which means no coagulation should be expected). Still, there are some behaviors that the <q>Improved barcode LFA model</q> considers, which were not contemplated in the <q>First barcode LFA model</q>, which have made us reduce our assumptions from 11 to 8. You can compare both of the list of assumptions by clicking on the respective tab.</Text>
      </Content>
      <Content style={{padding: '2vh', background: 'transparent', marginTop: '-6vh'}}>
        <Tabs
          tabBarGutter='4vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default AssumptionsTabs;
